import styled from "@emotion/styled";
import _configBase from "../../../configs/_configBase";
import { colors, fonts, mediaQueries } from "../../../configs/_configSite";

export default styled.p`
  ${_configBase};
  color: ${colors.lightGray};
  font-family: ${fonts.tertiary};
  font-size: 1.25rem;
  line-height: 1.5;
  text-align: justify;
  margin-bottom: 30px;

  @media (max-width: ${mediaQueries.md}px) {
    font-size: 1rem;
  }
  @media (max-width: ${mediaQueries.xs}px) {
    font-size: 0.875rem;
  }
`;
